import { useDispatch } from 'react-redux';

import { createAlert } from '@components/notification/NotificationSlice';
import { capitalizeFirstLetter } from '@utils/stringFormat';

interface NotifyOptions {
  classOverride?: string;
}

const useNotify = () => {
  const dispatch = useDispatch();
  const createSuccessAlert = (message: string, options?: NotifyOptions) =>
    dispatch(
      createAlert({
        alert: {
          message,
          type: 'success',
          ...(options?.classOverride && {
            classOverride: options.classOverride
          })
        }
      })
    );
  const createErrorAlert = (message?: string, options?: NotifyOptions) =>
    dispatch(
      createAlert({
        alert: {
          message: message
            ? capitalizeFirstLetter(message)
            : 'Something went wrong. Please try again later.',
          type: 'error',
          ...(options?.classOverride && {
            classOverride: options.classOverride
          })
        }
      })
    );
  const createWarningAlert = (message?: string, options?: NotifyOptions) =>
    dispatch(
      createAlert({
        alert: {
          message: message || 'Something went wrong. Please try again later.',
          type: 'warning',
          ...(options?.classOverride && {
            classOverride: options.classOverride
          })
        }
      })
    );
  return { createSuccessAlert, createErrorAlert, createWarningAlert };
};

export default useNotify;
